/* eslint-disable no-underscore-dangle */
import 'whatwg-fetch';
import React from 'react';
import {
  setupWindowServer,
  setupWindowErrorFunction,
  bundleLoaded,
  setupServiceRegistration,
  handlePayloadAndPreview,
  setupClickTrackCaller,
} from './setup-e2';
import { setupSdkFunctions } from './setup-sdk-functions';
import { setupE2Image } from './setup-e2-image';

let state = { hasInitialized: false, loaded: false, serverPayload: {} };

function runE2() {
  window.initPerf = performance.now();
  setupClickTrackCaller();
  setupWindowErrorFunction();
  setupWindowServer();
  setupSdkFunctions();
  setupE2Image();
  setupServiceRegistration();
  handlePayloadAndPreview();
  bundleLoaded();
}

export { state, runE2 };
